<template>
  <div>
    <query-card></query-card>
    <steps-card></steps-card>
  </div>
</template>

<script>
import StepsCard from '@/views/query/components/StepsCard'
import QueryCard from '@/views/query/components/QueryCard'

export default {
  components:{StepsCard,QueryCard},
  data() {
    return {
      
    };
  },
  methods:{

  }
};
</script>

<style lang="less" scoped>

</style>